import { ModuleWithProviders, NgModule } from '@angular/core';
import { CartComponent } from './cart.component';
import { StoreModule } from '@ngrx/store';
import { CartReducer } from './Domain/Facades/store/reducers/cart.reducers';
import { CartEffect } from './Domain/Facades/store/cart.effects';
import { EffectsModule } from '@ngrx/effects';
import { CartService } from './Domain/Services/cart.services';
import { SkeletonModule } from 'primeng/skeleton';
import { SkeltonComponent } from './Features/skelton/skelton.component';
import { LanguagePipe, LanguageService, SharedModule } from 'imakeapp-shared';



@NgModule({
  declarations: [
    CartComponent,
    SkeltonComponent
  ],
  imports: [
    SharedModule,
    StoreModule.forFeature('cart', CartReducer),
    EffectsModule.forFeature([CartEffect]),
    SkeletonModule
  ],
  exports: [
    CartComponent
  ],providers:[CartService,LanguagePipe
  ]
})
export class CartModule {

}
